export default "__VITE_ASSET__CxLksEby__"